import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const exportsApi = buildService('/claims/{id}/claim_cost_template_exports', {
  only: ['all', 'create', 'show', 'delete']
});
const claimCostTemplateExportsService = {
  useFetchAll: (setLoading, claimId) => {
    const [exports, setExports, fetchExports] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimId) return [];
        const response = await exportsApi.all(claimId);
        return Array.isArray(response) ? response : [];
      }, [claimId]),
      setLoading,
      initialStateValue: []
    });
    return [exports, setExports, fetchExports];
  },
  useCreate: (setLoading, setExports, exports, claimId) => {
    const createExport = serviceMethods.useCreate({
      callback: useCallback(async costSections => {
        if (!claimId) return;
        const response = await exportsApi.create(claimId, {
          cost_fields: costSections
        });
        setExports([response, ...exports]);
        return response;
      }, [exports, setExports, claimId]),
      setLoading
    });
    return [createExport];
  },
  usePolling: function (exports, fetchExports) {
    let enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const hasPendingExports = exports.some(exp => exp.status === 'pending');
    serviceMethods.usePolling({
      callback: fetchExports,
      enabled: enabled && hasPendingExports,
      intervalMs: 7000
    });
  },
  useDelete: (setLoading, setExports, exports, claimId) => {
    const deleteExport = serviceMethods.useDelete({
      callback: useCallback(async exportId => {
        if (!claimId) return;
        await exportsApi.delete(claimId, exportId);
        setExports(exports.filter(exp => exp.id !== Number(exportId)));
      }, [exports, setExports, claimId]),
      setLoading
    });
    return [deleteExport];
  }
};
claimCostTemplateExportsService.useCrud = (setLoading, claimId) => {
  const [exports, setExports, fetchExports] = claimCostTemplateExportsService.useFetchAll(setLoading, claimId);
  const [createExport] = claimCostTemplateExportsService.useCreate(setLoading, setExports, exports, claimId);
  const [deleteExport] = claimCostTemplateExportsService.useDelete(setLoading, setExports, exports, claimId);
  claimCostTemplateExportsService.usePolling(exports, fetchExports, true);
  return {
    exports,
    setExports,
    fetchExports,
    createExport,
    deleteExport
  };
};
export default claimCostTemplateExportsService;